import React from "react";

const GeoLiveMap: React.FC<any> = (props) => {
  return (
    <>
      <div>Hello Live Map</div>
    </>
  );
};

export default GeoLiveMap;
